<template>
  <div>
        <span title="More information" v-on:click="aboutPage = true" class="about">
            <font-awesome-icon icon="info"/>
        </span>
    <transition name="fade">
      <div v-if="aboutPage" v-on:click.self="aboutPage = false" class="aboutPage">
        <div class="aboutPage-content">
          <span v-on:click="aboutPage = false" style="float: right"> <font-awesome-icon icon="times"/></span>
          <h1>2020 Census Data Application</h1>
<!--          <div style="float: right; padding-left: 5px;">-->
<!--            <iframe style=" max-width: 100%;" width="560" height="315" src="https://www.youtube.com/embed/gX9D1B7dhc8"-->
<!--                    frameborder="0"-->
<!--                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"-->
<!--                    allowfullscreen></iframe>-->
<!--          </div>-->
          <p> SEMCOG’s new interactive mapping tool displays 2020 census results for every geographic unit in Southeast
            Michigan! View maps of Census 2020 population, households, and housing units to visualize the distribution
            of people and housing throughout the region.
          </p>
          <p>Select the geography in which you are interested - County, Community, School District, Census Tract, Block
            Group, or Block - and zoom into the map. Click on the features on the map to highlight a geographic area and
            view the Census 2020 results for that area. You can also choose to filter your geography by county or
            community using the provided lists. The download data feature allows users to download Census 2020 results
            for the currently selected type of geography.
          </p>
          <p>Download the column descriptions <a target="_blank" download="2020 Census Data Column Descriptions.xlsx" href="./2020 Census Data Column Descriptions.xlsx">here</a>.</p>
          <p>Create a custom area to view the combined Census 2020 results for multiple geographic units using the
            “Create Custom Area” polygon tool. Users can draw a polygon of any shape to select a large number of
            geographic areas and display the combined Census 2020 results, and this custom feature can be used on any
            level of geography!
          </p>
          <h2>Sources</h2>
          <div>
            <ul>
              <li><a href="https://www.census.gov/programs-surveys/decennial-census/decade/2020/2020-census-main.html" target="_blank">Census Bureau's Decennial Census</a>
              </li>
            </ul>
          </div>
          <h2>For Questions, please contact:</h2>
          <div>
            <p>Data: <a href="mailto:uppalapati@semcog.org">Sirisha
              Uppalapati</a></p>
            <p>Application: <a href="mailto:misiuk@semcog.org">Chad Misiuk</a></p>
          </div>
        </div>
      </div>
    </transition>

  </div>

</template>

<script>
export default {
  name: "AboutPage",
  data: function () {
    return {
      aboutPage: false,
    }
  },
}
</script>

<style scoped>

.about {
  float: right;
  padding: 5px;
}

.aboutPage {
  position: fixed;
  background: rgba(46, 60, 67, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  opacity: 1;
  overflow: hidden;
}

.aboutPage-content {
  background: white;
  max-width: 80%;
  border: #fffcfc solid 2px;
  border-radius: 10px;
  padding: 10px 30px;
  max-height: 80%;
  overflow: auto;
}

table {
  border-collapse: collapse;
  width: 100%;
}

th {
  text-align: center;
  border-bottom: 2px #64983D solid;
  padding-right: 25px;
}

td {
  border-bottom: 2px #64983D solid;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 1s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.fade-enter-active .aboutPage-content, .fade-leave-active .aboutPage-content {
  transition: transform 1s;
}

.fade-enter .aboutPage-content, .fade-leave-to .aboutPage-content {
  transform: translate(-50vw, -50vh) scale(0);
}

.fade-enter-to .aboutPage-content, .fade-leave-to .aboutPage-content {
  overflow: hidden;
}

</style>
